import { render } from "./StaffDatatableChairActions.vue?vue&type=template&id=93543350"
import script from "./StaffDatatableChairActions.vue?vue&type=script&lang=js"
export * from "./StaffDatatableChairActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__